import { apiGet, apiPut } from './client';
import { AssistantLogRow } from '../types/Monitoring';

export function getAssistantLog(
  fromDate?: string,
  toDate?: string,
): Promise<AssistantLogRow[]> {
  const params = new URLSearchParams();
  if (fromDate) params.set('fromDate', fromDate);
  if (toDate) params.set('toDate', toDate);
  const qs = params.toString();
  return apiGet<AssistantLogRow[]>(`/api/assistant-log${qs ? '?' + qs : ''}`);
}

export function setAssistantFeedback(
  assistantLogId: number,
  feedback: 1 | 2,   // 1=like, 2=dislike
): Promise<void> {
  return apiPut<{ feedback: number }, void>(
    `/api/assistant/feedback/${assistantLogId}`,
    { feedback },
  );
}
